
import {
ATTRIBUTS_BY_PERIMETRE_SUCCESS,
ATTRIBUTS_BY_PERIMETRE_FAIL,
ATTRIBUTS_GRILLE_FAIL,
LIST_ATTRIBUTS_GRILLE_SUCCESS
} from "../../actions/attribut/type";

const initialState = {
    attributs: [],
    attributsByPerimetre: [],
    attributsByPerimetreSelect: [],
  };
  const attributReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ATTRIBUTS_BY_PERIMETRE_SUCCESS:
            let newSelectedListe = payload.map((item) => {
              return { value: item.id, label: item.name };
            });
            return {
              ...state,
              attributsByPerimetre: payload,
              attributsByPerimetreSelect: newSelectedListe,
            };
          case ATTRIBUTS_BY_PERIMETRE_FAIL:
            return {
              ...state,
            };
          case LIST_ATTRIBUTS_GRILLE_SUCCESS :
            return {
              ...state,
              attributs : payload
          }
        case ATTRIBUTS_GRILLE_FAIL : 
        return {
          ...state,
        }
          default:
            return state;
        }
      };
      
      export default attributReducer;
      